import * as React from "react";
import {Accordion, AccordionSection, Table} from "@vebox/etui-core";
import {VeBoxCard} from "../../../components/card/VeBoxCard";
import {EditableSetting, SettingToUpdate} from "../../data/models/UpdatingSetting";
import {ChangeRegister, GroupedMappedEditSettings} from "./types";
import {accordionStyle} from "../../ReadAndWrite";
import {filterTableData, groupEditableSettingsByGroupName} from "../../ReadAndWrite/utils";
import {Theme} from "@vebox/etui-themes";
import {useTheme} from "@vebox/etui-system";
import {ReadAndWriteContext} from "../../../providers/ReadAndWriteProvider";
import {createColumnsForEditingTable, mapSettingsToTableData} from "./utils";


interface CurrentConfigurationTableData {
    handleOnCheckboxChange: ChangeRegister,
    handleOnTextInputChange: ChangeRegister,
    validateInput: ChangeRegister,
    settingsToUpdate: SettingToUpdate[]
    editableSetting: EditableSetting[],
    isLoading: boolean
}

export const EditConfigurationTableTable: React.FC<CurrentConfigurationTableData> = ({
                                                                                         editableSetting,
                                                                                         handleOnTextInputChange,
                                                                                         handleOnCheckboxChange,
                                                                                         validateInput,
                                                                                         settingsToUpdate,
                                                                                         isLoading
                                                                                     }) => {
    const {getTableHeadersName, registerFilterText, AppTranslations} = React.useContext(ReadAndWriteContext);
    const theme = useTheme();
    const groupedSettings = React.useMemo(() => {
        return groupEditableSettingsByGroupName(editableSetting?.filter(filterTableData(registerFilterText)))
    }, [editableSetting]);

    const dataSource: GroupedMappedEditSettings = React.useMemo(() => {
        const result: GroupedMappedEditSettings = {};
        groupedSettings.forEach((group) => {
            result[group.groupName] = mapSettingsToTableData(group.registers,
                handleOnTextInputChange,
                handleOnCheckboxChange,
                validateInput,
                settingsToUpdate);
        });
        return result;
    }, [groupedSettings]);

    return (
        <VeBoxCard className={"Section rw-card"}>
            <VeBoxCard.Header
                className={"rw-card-header"}
                title={AppTranslations.readAndWrite.parameters}
                singleLineTitle={true}
            />
            <VeBoxCard.Body className={"rw-card-body no-padding"}>
                <Accordion>
                    {groupedSettings.map((accordionSection, index) => (
                        <AccordionSection
                            key={index}
                            name={accordionSection.groupName}
                            keepSectionContentInDOM={false}
                            styles={{
                                ...accordionStyle(theme as Theme),
                                sectionContent: {height: ((accordionSection.registers.length + 1) * 47) + "px"}
                            }}
                            defaultOpen={index === 0}
                        >
                            <Table
                                pagination={false}
                                loading={isLoading}
                                styles={{th: {fontWeight: "bold"}}}
                                dataSource={dataSource[accordionSection.groupName]}
                                columns={createColumnsForEditingTable(getTableHeadersName)}
                            />
                        </AccordionSection>
                    ))}
                </Accordion>
            </VeBoxCard.Body>
        </VeBoxCard>
    );
};
